import { useEffect } from 'react';
import { useGetFunnelStatus } from 'src/components/enterprise/features/HomePage/components/OnboardingFunnelWrapper/hooks/useGetFunnelStatus';
import {
  OnboardingFunnelBannerCopy,
  getOnboardingFunnelBannerCopy,
} from 'src/components/enterprise/features/HomePage/components/OnboardingFunnelBanner/utils/getOnboardingFunnelBannerCopy.utils';
import { getOnboardingFunnelRedirectUrl } from 'src/components/enterprise/features/HomePage/components/OnboardingFunnelBanner/utils/getOnboardingFunnelRedirectUrl.utils';
import { OnboardingFunnelStatus } from 'src/components/enterprise/features/HomePage/types/OnboardingFunnel';

export interface UseOnboardingFunnelReturnType {
  showBanner: boolean;
  bannerCopy: OnboardingFunnelBannerCopy;
  href: string;
}

const VISIBLE_FUNNEL_STATUSES = [
  OnboardingFunnelStatus.NOT_STARTED,
  OnboardingFunnelStatus.IN_PROGRESS,
];

export const useOnboardingFunnel = (
  corpId: string
): UseOnboardingFunnelReturnType => {
  const { isLoading, hasError, funnelDetails, fetchFunnelStatus } =
    useGetFunnelStatus(corpId);

  useEffect(() => {
    fetchFunnelStatus();
  }, [fetchFunnelStatus]);

  const showBanner =
    !isLoading &&
    !hasError &&
    !!funnelDetails &&
    VISIBLE_FUNNEL_STATUSES.includes(funnelDetails.funnelStatus);

  const bannerCopy = getOnboardingFunnelBannerCopy(funnelDetails?.funnelStatus);

  const href = getOnboardingFunnelRedirectUrl(
    corpId,
    funnelDetails?.funnelSteps ?? {}
  );

  return { showBanner, bannerCopy, href };
};
